import { render, staticRenderFns } from "./barcodepay.vue?vue&type=template&id=6e5c619b&scoped=true&"
import script from "./barcodepay.vue?vue&type=script&lang=js&"
export * from "./barcodepay.vue?vue&type=script&lang=js&"
import style0 from "./barcodepay.vue?vue&type=style&index=0&id=6e5c619b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5c619b",
  null
  
)

export default component.exports